import { Menu, Text } from '@approvalmax/ui/src/components';
import { intl } from '@approvalmax/utils';
import { FC } from 'react';
import { getCountryFlagByCountryCode } from 'shared/helpers';

import { getCountryCodeByCurrency } from '../../Wallets.helpers';
import { CurrencyMenuItemProps } from './CurrencyMenuItem.types';

export const CurrencyMenuItem: FC<CurrencyMenuItemProps> = (props) => {
    const { id, subName, balance, showBalance = false, ...restProps } = props;

    const IconFlag = getCountryFlagByCountryCode(getCountryCodeByCurrency(id));

    return (
        <Menu.Item
            {...restProps}
            id={id}
            name={id}
            subName={subName}
            startIcon={IconFlag ? <IconFlag width={22} /> : undefined}
            endIcon={
                showBalance ? (
                    <Text font='label' fontSize='medium' color='midnight70'>
                        {intl.formatNumber(balance ?? 0)}
                    </Text>
                ) : undefined
            }
        />
    );
};

CurrencyMenuItem.displayName = 'CurrencyMenuItem';
